import { createStore, storeKey } from 'vuex'
import gtmHelper from './gtm-helper'

export default createStore({
	state() {
		return {
			items: [],
			tagGroups: [],
			selectedItemIds: [],
			openGroups: [],
			searchTerm: '',
		}
	},
	mutations: {
		setItems(state, items) {
			state.items = items
		},
		setSearchTerm(state, searchTerm) {
			state.searchTerm = searchTerm
		},
		setTagGroup(state, group) {
			// make a tag object based on all the item tags in the items
			let tags = []
			// loop through all items
			state.items.map(item => {
				// console.log('item', group.key, item);
				// loop through all groups tags
				if (item[group.key]) {
					if (item[group.key].length > 0) {
						// IF THE ITEM HAS A GROUP OF TAGS THAT MATCH THE GROUP KEY
						item[group.key].map(tagInGroup => {
							// console.log('tagInGroup', tagInGroup);
							// LOOPING THROUGH EACH TAG TYPE IN THE GROUP
							if (tags.length === 0) {
								// FIRST TAG IN GROUP, MANUALLY SET IT
								let tag = {
									slug: tagInGroup.slug,
									title: tagInGroup.title,
									items: [item.id],
									disabled: false,
									selected: false
								}
								tags.push(tag)
							} else {
								if (!tags.find(t => t.slug === tagInGroup.slug)) {
									// IF THE TAG IS NOT IN THE TAGS ARRAY ALREADY
									let tag = {
										slug: tagInGroup.slug,
										title: tagInGroup.title,
										items: [item.id],
										disabled: false,
										selected: false
									}
									tags.push(tag)
								} else {
									// if this tag is in tags already, then just add add item id to it
									tags.find(t => t.slug === tagInGroup.slug).items.push(item.id)
								}
							}
						})
					}
				}
			})
			tags.sort((a, b) => (a.items.length > b.items.length) ? -1 : 1)
			state.tagGroups.push({ key: group.key, title: group.title, tags: tags });
		},
		setTagStatus(state, payload) {
			// console.log('setTagStatus', payload)
			const group = state.tagGroups.find(group => group.title === payload.title)
			group.tags.find(tag => {
				// where the slug property of the tag matches slug of what was clicked, toggle selected property
				if (tag.slug === payload.slug) {
					tag.selected = !tag.selected
					if (tag.selected) {
						gtmHelper({
							type: "select filter",
							group: group.title,
							target: tag.slug,
						})
					} else {
						gtmHelper({
							type: "unselect filter",
							group: group.title,
							target: tag.slug,
						})
					}
				}
			})
			// get Item Ids from tags
			let selectedTags = group.tags.filter(tag => tag.selected)
			// console.log('selectedTags', selectedTags);
			// set selectedItemIds equal to the ids that are common to all selected tags
			var selectedItemIds
			if (selectedTags.length > 0) {
				selectedItemIds = selectedTags.concat().reduce((acc, curr) => {
					return acc.filter(id => curr.items.includes(id))
				}, selectedTags[0].items)
				// console.log('selectedItemIds', selectedItemIds);
			}
			// group.tags.map(tag => {
			// 	// where any tag in this group has a recipe id that is not included in a tag that is selected's recipe ids, set disabled property to true
			// 	if (tag.items.length > 0) {
			// 		if (selectedTags.length > 0 && selectedItemIds.length > 0) {
			// 			tag.disabled = !selectedItemIds.some(id => tag.items.includes(id))
			// 		} else {
			// 			// unless of course there is nothing selected, in which case all tags are enabled
			// 			tag.disabled = false
			// 		}
			// 	}
			// })

			// for each tag group, iterate through all tags in each tag group that is not it
			state.tagGroups.map(group => {

				if (group.title != payload.title) {
					group.tags.map(tag => {
						if (tag.items.length > 0) {
							if (selectedTags.length > 0 && selectedItemIds.length > 0 && !tag.selected) {
								tag.disabled = !selectedItemIds.some(id => tag.items.includes(id))
							} else {
								// unless of course there is nothing selected, in which case all tags are enabled
								tag.disabled = false
							}
						}
					})
				}

			})

		}, // setTagStatus
		setOpenGroups(state, payload) {
			state.openGroups = payload
		},
		addOpenGroup(state, payload) {
			state.openGroups.push(payload)
		},
		addOpenGroupByTitle(state, payload) {
			let group = state.tagGroups.find(group => group.title === payload)
			state.openGroups.push(group.key)
		},
		removeOpenGroup(state, payload) {
			state.openGroups.splice(state.openGroups.indexOf(payload), 1)
		},
		// removeTag(state, slug) {
		// 	console.log('removeTag', slug)
		// 	state.tagGroups.map(group => {
		// 		console.log('group', group)
		// 		group.tags.map(tag => {
		// 			// console.log('tag', tag)
		// 			if (tag.slug === slug) {
		// 				console.log('tag found', tag, slug)
		// 				tag.selected = false
		// 			}
		// 		})
		// 	})
		// }
	},
	action: {
		setItems(commit, items) {
			commit('setItems', items)
		},
		setTagGroup(commit, group) {
			commit('setTagGroup', group)
		},
		setTagStatus(commit, payload) {
			commit('setTagStatus', payload)
		},
		setOpenGroups(commit, payload) {
			commit('setOpenGroups', payload)
		}
	},
	getters: {
		allItems: state => state.items,
		totalCount: state => {
			// console.log('asdf', state.items.length)
			return state.items.length
		},
		// get items that match selected filters
		itemsFiltered: state => {
			// establish a variable for the items to go into
			let filteredItems = []
			// console.log('filteredItemsStart', filteredItems);
			// identify tag groups with nothing active
			let groupsThatHaveNoActiveTags = []
			// get tag group count from state
			let totalGroups = state.tagGroups.length
			state.tagGroups.map((group, index) => {
				// for each tag group
				// get active tags for this group
				let activeTags = group.tags.filter(tag => tag.selected)
				// console.log('activeTags', activeTags);
				// if there are any
				if (activeTags.length > 0) {
					// for each item in state, check if it's id is in any of the active tags  array
					// if it is, return it
					let items = state.items.filter(item => {
						// return activeTags.every(tag => {
						return activeTags.some(tag => {
							return tag.items.includes(item.id)
						})
					})
					filteredItems.push(items)
					// console.log('new active tag logic');
				} else {
					// if there aren't any active tags
					// console.log('no active tags')
					filteredItems.push(state.items)
					groupsThatHaveNoActiveTags.push(index)
				}
			})
			// console.log('filteredItems', filteredItems, filteredItems.length);

			// console.log('filteredItems', filteredItems);
			// console.log('groupsThatHaveNoActiveTags', groupsThatHaveNoActiveTags, totalGroups);
			if (groupsThatHaveNoActiveTags.length < totalGroups) {
				// if there are any groups that have no active tags, omit those from the result
				// console.log('X', filteredItems);
				// groupsThatHaveNoActiveTags.map(group => {
				// 	console.log('XG', group)
				// 	filteredItems.splice(group, 1)
				// })
				// https://stackoverflow.com/questions/9425009/remove-multiple-elements-from-array-in-javascript-jquery
				for (var i = groupsThatHaveNoActiveTags.length - 1; i >= 0; i--) {
					filteredItems.splice(groupsThatHaveNoActiveTags[i], 1);
				}
				// console.log('X', filteredItems);
			}
			// console.log('filteredItems', filteredItems, filteredItems.length);
			if (filteredItems.length > 1) {
				// filteredItems = filteredItems.reduce((acc, curr) => {
				// 	return acc.filter(item => curr.includes(item))
				// }, filteredItems[0])
				// go through each array in filteredItems and return only the items that are in all of them
				// go through each array
				// go through each item in the first array
				// add those items to an accumulator
				// go through the next array remove items from the accumulator if they don't exist in that array
				// repeat until all arrays have been checked
				// return the accumulator
				// https://stackoverflow.com/questions/11076067/finding-matches-between-multiple-javascript-arrays
				let result = filteredItems.shift().reduce(function (res, v) {
					if (res.indexOf(v) === -1 && filteredItems.every(function (a) {
						return a.indexOf(v) !== -1;
					})) res.push(v);
					return res;
				}, []);
				// console.log('result.popular', result[0]);
				if (typeof result[0].popular !== 'undefined') {
					// sort by popularity
					// console.log('sort by popularity');
					result.sort((a, b) => {
						return b.popular - a.popular
					})
				}
				// console.log('result', result);
				filteredItems = result
			}
			// console.log('filteredItems', filteredItems);
			let itemsToReturn = [...new Set(filteredItems.flat())]
			state.selectedItemIds = itemsToReturn.map(item => item.id)
			return itemsToReturn
		},
		getActiveTags: state => {
			let activeTags = []
			state.tagGroups.map(group => {
				// console.log('group', group);
				group.tags.map(tag => {
					// console.log('tag', tag);
					if (tag.selected) {
						let extendedTag = tag
						extendedTag.groupTitle = group.title
						activeTags.push(extendedTag)
					}
				})
			})
			return activeTags
		},
		getSearchTerm: state => state.searchTerm,
	}
})